import { Injectable, QueryList, TemplateRef } from '@angular/core';
import { FormControlTemplatesDirective } from './form-control-templates.directive';
import { FormRoGridTemplatesComponent } from './form-ro-grid-templates/form-ro-grid-templates.component';
import { FormDropdownTemplatesComponent } from './form-dropdown-templates/form-dropdown-templates.component';
import { FormCardsTemplatesComponent } from './form-cards-templates/form-cards-templates.component';

@Injectable({
  providedIn: 'root'
})
export class FormControlTemplatesService {

  templateRefs: QueryList<FormControlTemplatesDirective>;
  displayGridTmpltRefs: QueryList<FormControlTemplatesDirective>;
  dropDownTmpltRefs: QueryList<FormControlTemplatesDirective>;
  cardsTmpltRefs: QueryList<FormControlTemplatesDirective>

  constructor() { }

  getTemplate(templateName:string, templateType:'dropdown' | 'cards' | 'displayGrid' | 'default' = 'default'): TemplateRef<any> {
   try{
    if(templateType == 'dropdown'){
      return this.dropDownTmpltRefs.toArray().find(x => x.name.toLowerCase() == templateName.toLowerCase()).template;
     }
     else if(templateType == 'cards'){
      return this.cardsTmpltRefs.toArray().find(x => x.name.toLowerCase() == templateName.toLowerCase()).template;
     }
     else if(templateType == 'displayGrid'){
      return this.displayGridTmpltRefs.toArray().find(x => x.name.toLowerCase() == templateName.toLowerCase()).template;
     } else{
      return this.templateRefs.toArray().find(x => x.name.toLowerCase() == templateName.toLowerCase()).template;
     }
   }catch(reason) {
      return null;
    }
  }

}
